import script from "./manualFeeding.vue?vue&type=script&setup=true&lang=ts"
export * from "./manualFeeding.vue?vue&type=script&setup=true&lang=ts"

import "./manualFeeding.vue?vue&type=style&index=0&id=1a1cf2ae&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1cf2ae"]])

export default __exports__